import { useEffect } from 'react';

import {
  MissingTranslationsBar,
  reportMissingTranslation,
} from './MissingTranslationsBar';

// Type for our custom window properties
interface DevToolsWindow extends Window {
  __missingTranslationsQueue?: string[];
  __reportMissingTranslation?: (key: string) => void;
}

export function DevTools() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const devWindow = window as DevToolsWindow;

      // Process any queued missing translations
      const queue = devWindow.__missingTranslationsQueue || [];

      // Set up the real reporter
      devWindow.__reportMissingTranslation = reportMissingTranslation;

      // Report all queued translations
      queue.forEach((key: string) => {
        reportMissingTranslation(key);
      });

      // Clear the queue
      devWindow.__missingTranslationsQueue = [];
    }

    return () => {
      if (typeof window !== 'undefined') {
        const devWindow = window as DevToolsWindow;
        delete devWindow.__reportMissingTranslation;
        delete devWindow.__missingTranslationsQueue;
      }
    };
  }, []);

  // Only render in development
  if (!import.meta.env.DEV) {
    return null;
  }

  return <MissingTranslationsBar />;
}
